function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.625 1.75V3h-5V1.75h-1.25V3H3.75c-.694 0-1.244.563-1.244 1.25L2.5 13c0 .688.556 1.25 1.25 1.25h8.75c.688 0 1.25-.563 1.25-1.25V4.25c0-.688-.563-1.25-1.25-1.25h-.625V1.75h-1.25zm.625 6.875H8.125v3.125h3.125V8.625zM3.75 13h8.75V6.125H3.75V13z",
  fill: "currentColor"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/calendar.1844412b.svg";
export { SvgComponent as ReactComponent };